window.loadMore = function (e) {
    const hiddenImages = document.querySelectorAll('.hidden-image');
    const seeLess = document.querySelector('.see-less-button');
    const loadMoreButton = e.currentTarget;
    hiddenImages.forEach(function (image) {
        image.style.display = 'block';
    });
    loadMoreButton.style.display = 'none';
    seeLess?.classList.remove('hidden');
}

window.seeLess = function (e) {
    const hiddenImages = document.querySelectorAll('.hidden-image');
    const loadMoreButton = document.querySelector('.load-more-button');
    const seeLess = e.currentTarget;
    hiddenImages.forEach(function (image) {
        image.style.display = 'none';
    });
    loadMoreButton.style.display = 'flex';
    seeLess?.classList.add('hidden');
}